export default "__VITE_ASSET__CTF46QCM__"